import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useAddHotspotHistory } from './useAddHotspotHistory';

export const useNavigatedRoutes = () => {
  const { groupId, sceneId } = useSelector((state) => state.worldParams);
  const addHotspotHistory = useAddHotspotHistory();

  const [activeHotspot, setActiveHotspot] = useState('');

  const history = useHistory();

  const handleUpdateRoute = useCallback(
    (hsId = '') => {
      if (hsId) {
        history.push(`/${groupId}/${sceneId}/${hsId}`);
        setActiveHotspot(hsId);
        addHotspotHistory(hsId);
        return;
      }
      history.push(`/${groupId}/${sceneId}`);
      setActiveHotspot('');
    },
    [addHotspotHistory, groupId, history, sceneId]
  );

  return [handleUpdateRoute, activeHotspot];
};
